import React, { useState } from 'react';
import { View } from '@uncinc/react-drupal-core';
import i18next from '../../../config/i18next';

import {
  Container,
  Divider,
} from '../../../components';

import {
  FooterMenu,
  FooterCopyrightMenu,
  FooterMenuWithImages,
} from '../..';

const FooterCampaign = ({ campaignEntity }) => {
  const [menusToggled, setMenusToggled] = useState([]);
  const campaignFooterId = campaignEntity.getIn([0, 'entity', 'field_footer_id', 0, 'value']);
  const campaignBlockReferenceId = campaignEntity.getIn([0, 'entity', 'field_block_reference', 0, 'target_id'], null);
  const campaignBlockReferenceEntity = campaignEntity.getIn([0, 'entity', 'field_block_reference', 0, 'entity'], null);

  const toggleMenu = (key) => {
    setMenusToggled((prevState) => ({
      ...menusToggled,
      [key]: !prevState[key],
    }));
  };
  return (
    <div className="Footer">
      <Container>
        <div className="Footer__logo" />
      </Container>

      <FooterMenu
        id={campaignFooterId}
        campaignBlockReferenceId={campaignBlockReferenceId}
        campaignBlockReferenceEntity={campaignBlockReferenceEntity}
        toggleMenu={toggleMenu}
        menusToggled={menusToggled}
        isCampaign
      />
      <Divider />
      <Container>
        <div className="Footer__secondary row">
          <div className="Footer__secondary__initative Footer__secondary__supported col-sm-12 col-md-5">
            <FooterMenuWithImages className="Footer__initative" id="footer-initiative" title={i18next.t('footer_inititive')} />
          </div>
          {/* Region for secondary footer supporters */}
          <div className="Footer__secondary--support col-sm-12 col-sm-7 col-md-7 order-sm-2 order-md-2">
            <div className="row">
              <div className="Footer__secondary__supported col-sm-12 col-md-6">
                <FooterMenuWithImages id="footer-supported-by" title={i18next.t('footer_supported')} />
              </div>
              <div className="Footer__secondary__registered col-sm-12 col-md-6">
                <FooterMenuWithImages id="footer-registered-by" title={i18next.t('footer_registered')} />
              </div>
            </div>
          </div>
        </div>
      </Container>
      <div className="">
        <Divider />
        <View id="partners" display="block_1" />
        <Divider />
      </div>
      <Container>
        <div className="Footer__copyright">
          <div className="Footer__copyright--copyright">Copyright © { new Date().getFullYear()} Oranje Fonds</div>
          <FooterCopyrightMenu />
        </div>
      </Container>
    </div>
  );
};

export default FooterCampaign;
